import "./PageHeader.css";
import { PageHeaderProps } from "../types/PageHeaderProps";
import React from "react";
import { PageCrumb } from "../PageCrumb/PageCrumb";

export const PageHeader = (props: PageHeaderProps) => {
    const { pathCrumbs, currentPageCrumb, rhsInteractiveElements } = props;
    return (
        <div
            className="flex align-items-center justify-content-between page-header"
            data-cy="page-header"
        >
            <div className="flex align-items-center" style={{ height: "52px" }}>
                <PageCrumb
                    currentPageCrumb={currentPageCrumb}
                    pathCrumbs={pathCrumbs}
                />
            </div>
            <div
                className="page-header-buttons flex flex-row align-items-center"
                data-cy="page-header-buttons"
            >
                {rhsInteractiveElements}
            </div>
        </div>
    );
};
